<template>
    <div>
        <el-dialog title="查看" 
        :before-close="beforeClose" 
        width="60%"
        :modal-append-to-body="false" 
        :visible.sync="visible">
            <avue-form ref="form" v-model="details" :option="viewOption">
                <template  slot="test">
                    <avue-crud :data="viewTopicData" :option="topicOption">
                        <template slot="averageScore" slot-scope="scope">
                            <span :style="scope.row.averageScore<scope.row.baseScore?'color:#DD001B':'color:#ACF227'">{{ scope.row.averageScore }}</span>
                        </template>
                    </avue-crud>
                </template>
            </avue-form>
        </el-dialog>
    </div>
</template>
<script>
import {add, getDetail, getList, remove, update,getReportDetail,getProjectDictionary} from "@/api/crmedical/examine/examinereport";
import {viewFormOption,topicOption} from "./examinereport-form-option";
export default {
    data(){
        return{
            visible:false,
            topicOption:topicOption,
            viewOption:viewFormOption,
            viewTopicData:[],
            details:{},
        }
    },
    methods:{
        // 获取考核列表传入的数据
        setdata(data){
           this.visible = true;
            this.details = {};
            this.viewTopicData = [];

           getReportDetail({id:data.id}).then(res=>{
               this.details = res.data;
             this.details.contractCode = data.contractCode;
             this.details.contractName = data.contractName;
               res.data.detailList.forEach(ele=>{
                   ele.projectId = data.projectId;
               })
               this.viewTopicData = res.data.detailList;
           })
          
        },
        beforeClose(done){
            this.$emit('update:visible',false);
            done();
        }
    }
    
}
</script>
